import React, { useState } from 'react';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const Wrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  '@screen >= $xs': {
    padding: '0px',
    paddingTop: '18px',
  },
  '@screen >= $xl': {
    padding: '32px 0px 0px 0px',
    paddingBottom: '0px',
  },
});

const StarButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  '&:focus': {
    outline: '2px solid $primary1',
    outlineOffset: '2px',
  },
  '&:hover': {
    opacity: 0.8,
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
});

const Helper = styled('p', {
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '14px',
  lineHeight: '20px',
  color: '#002677',
  margin: '0px',
  textAlign: 'center',
});

export const StarRating = ({
  starCount = 5,
  leftLabel = 'Not Likely',
  rightLabel = 'Extremely Likely',
  value,
}) => {
  const [rating, setRating] = useState(0);

  const ratingValue = (data) => {
    setRating(data);
    if (value) {
      value(data);
    }
  };

  return (
    <Wrapper>
      <Helper>{leftLabel}</Helper>
      {[...Array(starCount)].map((_, i) => {
        const starNumber = i + 1;
        const isFilled = i < rating;

        return (
          <StarButton
            key={`star-${starNumber}`}
            type="button"
            aria-label={`Rate ${starNumber} out of ${starCount} stars`}
            onClick={() => {
              return ratingValue(starNumber);
            }}
          >
            <IconSymbol
              icon="star"
              variant={isFilled ? 'solid' : 'outlined'}
              size="34px"
              color="$primary1"
            />
          </StarButton>
        );
      })}
      <Helper>{rightLabel}</Helper>
    </Wrapper>
  );
};

StarRating.propTypes = {
  starCount: PropTypes.number,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  value: PropTypes.func,
};

StarRating.defaultProps = {
  starCount: 5,
  leftLabel: 'Not Likely',
  rightLabel: 'Extremely Likely',
  value: null,
};
